import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_PermissionUser = {
    _v1: {
        assignPermissions: { method: HttpMethod.POST, path: '/pah/permissions/assign/app-permissions' }
    }
};
//# sourceMappingURL=api-def.js.map